import React from 'react';
import { useTranslation } from 'react-i18next';

import { OralExamErrorState } from '@/common/components/oralExam/OralExamErrorState';

export type StudentSessionExpiredScreenProps = {
  onLeave: () => void;
};

/**
 * Shown when the scheduled exam window has elapsed while the run never reached a
 * terminal state (backend computes `operationalFault: session_expired`). Kept in
 * its own module so it can be rendered *outside* the LiveKit shell by
 * `OralExamLiveSession` (releasing cam/mic) without pulling in the heavy
 * `OralExamStage` dependency graph.
 */
export function StudentSessionExpiredScreen({ onLeave }: StudentSessionExpiredScreenProps) {
  const { t } = useTranslation();

  return (
    <OralExamErrorState
      testID="oral-exam-student-expired"
      title={t('oralExam.sessionExpiredTitle')}
      message={t('oralExam.sessionExpiredBody')}
      tone="neutral"
      leave={onLeave}
      leaveLabel={t('oralExam.leaveExam')}
    />
  );
}
